export const environment = {
    production: true,
    base: '//booking.intersprint-overnight.at/api'
};
